import React, { useRef } from "react";
import { Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip } from "@mui/material";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import { Menu as PrimeMenu } from "primereact/menu";

export function LaunchScreenTable({ items = [], onEdit, onDelete }) {
  const menuRefs = useRef([]);

  return (
    <Box>
      <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px", mb: 1 }}>
        Launch Screens
      </Typography>
      <TableContainer sx={{ height: "100%" }}>
        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
          <TableHead style={{ backgroundColor: "background.upload" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Title</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left",backgroundColor: "background.upload" }} align="left">Banners</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Status</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.length > 0 ? (
              items.map((item, index) => {
                menuRefs.current[index] = menuRefs.current[index] || React.createRef();
                const banners = Array.isArray(item.banners) ? item.banners : [];
                const bannerSummary = banners
                  .slice(0, 2)
                  .map((b) => b?.heading || b?.description || `Banner ${b?.id || ''}`)
                  .filter(Boolean)
                  .join(", ");
                const extra = banners.length > 2 ? ` +${banners.length - 2}` : '';

                return (
                  <TableRow key={item.id}>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>{index + 1}</TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>{item.title || '-'}</TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>{bannerSummary}{extra}</TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                      {item.is_active === false ? (
                        <Box sx={{ width: "120px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }}>
                          <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red", textAlign: "center", textTransform: "uppercase", width: "88px" }}> Inactive</Typography>
                        </Box>
                      ) : (
                        <Box sx={{ width: "67px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }} >
                          <Typography sx={{ textAlign: "center", fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green", textTransform: "uppercase", width: "67px" }}>Active</Typography>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                      <PrimeMenu
                        model={[
                          { label: "Edit", command: () => onEdit && onEdit(item) },
                          { label: "Delete", command: () => onDelete && onDelete(item) },
                        ]}
                        popup
                        ref={menuRefs.current[index]}
                        style={{ marginTop: "-10px" }}
                        className="custom-menu"
                      />
                      <Tooltip title="Actions" arrow>
                        <IconButton
                          sx={{ textTransform: "none" }}
                          onClick={(event) =>
                            menuRefs.current[index]?.current?.toggle(event)
                          }
                        >
                          <MoreHorizSharpIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={8} sx={{ textAlign: "center", height: "200px" }}>
                  No Launch Screens Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}



